<template>
  <div class="ib">
    <div class="ib-container">
      <div>
        <img :src="icon" alt="icon" />
      </div>
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBox',
  props: {
    icon: {
      type: String,
    },
  },
};
</script>
